import {mapGetters} from 'vuex';
import FormatCurrency from '../mixins/format-currency';

const TransactionsMixin = (list) => {
  return {
    data(){
      return{
        list: '',
        filter: [],
        filteredTransactions: [],
      }
    },

    mixins: [FormatCurrency],

    computed:{
      ...mapGetters([
        'getStatus',
        'getHolder',
        'getFilteredTransactions',
        'isPageLoaded',
      ]),
    },

    methods:{
      getPaymentType(paymentType){
        if(paymentType == 'cash') return 'Gotovina';
        else if(paymentType == 'virman') return 'Virman';
        else if(paymentType == 'coupon') return 'Darovni bon';
        else return 'Kartica'
      },
    },

    watch:{
      filter(val){
        this.filteredTransactions = this.getFilteredTransactions({searchKey: val, list: this.$store.state.receivedData[this.list].list});
      },

      isPageLoaded(value){
        if(value){
          this.type = this.$route.params.type == 'prodaja' ? 'sales' : 'reservations';
          this.list = this.$store.state.isTicket ? 'ticketSales' : 'subscriptionSales';
          if(this.type != 'sales') this.list = this.type;
          this.filter = ['online_sold', 'partner_sold', 'offline_sold', 'theatre_manager', 'sponsor', 'employee', 'lease', 'system_reserve', 'reservation'];
        }
      }
    }
  }
}

export default TransactionsMixin;


// WEBPACK FOOTER //
// ./src/mixins/transactions-mixin.js